import type { FunnelMetric, FunnelStages } from "../../../types/dealFunnel";

const emptyMetric = (): FunnelMetric => ({ count: 0, volume_gbp: 0 });

/** Apollo closes from a stage block; safe when the key is omitted mid-rollout. */
export function closedApolloMetric(stages: FunnelStages): FunnelMetric {
  return stages.closed_apollo ?? emptyMetric();
}

/**
 * Non-Apollo closes for table display.
 * `reached_closed` includes Apollo, so Closed − Apollo would otherwise double-count.
 */
export function nonApolloClosedMetric(stages: FunnelStages): FunnelMetric {
  const apollo = closedApolloMetric(stages);
  return {
    count: Math.max(0, stages.reached_closed.count - apollo.count),
    volume_gbp: Math.max(
      0,
      stages.reached_closed.volume_gbp - apollo.volume_gbp,
    ),
  };
}
